"use client";

import React from "react";
import ZodiacSign, {
  type ZodiacSignData,
  type ZodiacSignName,
  zodiacSignsData,
} from "../ui/ZodiacSign";

interface IconWithTextProps {
  onZodiacClick?: (data: ZodiacSignData) => void;
  selectedSign?: string;
}

const zodiacOrder: ZodiacSignName[] = [
  "mesham",
  "rishabam",
  "mithunam",
  "kadagam",
  "simmam",
  "kanni",
  "thulam",
  "viruchigam",
  "dhanusu",
  "magaram",
  "kumbam",
  "meenam",
];

export default function IconWithText({
  onZodiacClick,
  selectedSign,
}: IconWithTextProps) {
  const handleSelect = (signId: ZodiacSignName) => {
    const signData = zodiacSignsData[signId];
    if (signData) {
      onZodiacClick?.(signData);
    }
  };

  return (
    <div className="py-4 px-4">
      <div className="flex flex-wrap gap-2 sm:gap-2 md:gap-0 justify-between">
        {zodiacOrder.map((signId) => {
          const zodiac = zodiacSignsData[signId];
          const isSelected = selectedSign === zodiac?.signName;

          return (
            <button
              key={signId}
              type="button"
              onClick={() => handleSelect(signId)}
              className={`flex flex-col items-center p-3 rounded-lg transition ${
                isSelected ? "bg-blue-100 ring-2 ring-blue-500" : ""
              }`}
            >
              <ZodiacSign
                sign={signId}
                topText={zodiac?.signName}
                bottomText={zodiac?.tagline}
                size={68}
                textClassName="text-1B1B1B text-center text-xs mt-1"
              />
            </button>
          );
        })}
      </div>
    </div>
  );
}